import React from 'react';
import { ThemeProvider } from '@dion-web/ui';
import * as ReactDOM from 'react-dom/client';
import { DARK_THEME } from 'shared/theme';
import { GLOBAL_STYLES } from 'shared/theme/global-styles';
import { DionWebContainerApp } from '@dion-web/container';
import { ErrorBoundary } from 'widgets/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));

const VideoAppAdapterMFLazy = React.lazy(() => import('./integrations/expose/VideoAppAdapterMF'));

root.render(
  <ErrorBoundary>
    <ThemeProvider
      theme={ DARK_THEME }
      globalStyles={ GLOBAL_STYLES }
      defaultMode="dark"
    >
      <DionWebContainerApp
        basePath={ 'video' }
        appAdapterMF={ VideoAppAdapterMFLazy }
      />
    </ThemeProvider>
  </ErrorBoundary>
);
